const covid19Modal = () => {
    const btnCloseModal = document.querySelector(".js-modalClose");
    const modal = document.querySelector(".modal");
    const overlay = document.querySelector(".modal__overlay");
    const trigger = document.querySelectorAll(".js-modalOpen");
    if (!btnCloseModal) { return false; };

    const closeModal = () => {
        modal.classList.add("is-hidden");
        overlay.classList.add("is-hidden");
    };

    trigger.forEach((target) => {
        target.addEventListener('click', () => {
            modal.classList.remove("is-hidden");
            overlay.classList.remove("is-hidden");
        });
    });
    btnCloseModal.addEventListener("click", closeModal);
    overlay.addEventListener('click', closeModal);
}

covid19Modal();